// extracted by mini-css-extract-plugin
module.exports = {"default":"SvgIcon_default_1O3c2"};